import { register } from '@shopify/theme-sections';
import Favourites from '../libraries/Favourites';

register('featured-collection', {
    onLoad() {
        Favourites.init();
        Favourites.initButtons();
    }
});